import { render } from "./option-input.vue?vue&type=template&id=06e1ef12&scoped=true"
import script from "./option-input.vue?vue&type=script&lang=js"
export * from "./option-input.vue?vue&type=script&lang=js"

import "./option-input.vue?vue&type=style&index=0&id=06e1ef12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e1ef12"]])

export default __exports__